import Vue from 'vue';
// Swiper 12 core CSS bundle (core + navigation + pagination + autoplay module styles)
import 'swiper/css/bundle';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
const defaultOptionsFactory = () => {
    return {
        // Modules are registered per-instance via the `modules` option (see initSwiper)
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: true,
        loop: true,
        watchOverflow: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
        breakpoints: {
            360: { slidesPerView: 1, spaceBetween: 10, slidesPerGroup: 1, loopAddBlankSlides: true },
            544: { slidesPerView: 2, spaceBetween: 10, slidesPerGroup: 2, loopAddBlankSlides: true },
            768: { slidesPerView: 3, spaceBetween: 10, slidesPerGroup: 3, loopAddBlankSlides: true },
            992: { slidesPerView: 3, spaceBetween: 15, slidesPerGroup: 3, loopAddBlankSlides: true },
            1200: { slidesPerView: 4, spaceBetween: 15, slidesPerGroup: 4, loopAddBlankSlides: true },
        },
    };
};
export default Vue.extend({
    name: 'SwiperWrapper',
    props: {
        options: {
            type: Object,
            default: defaultOptionsFactory,
        },
        items: {
            type: Array,
            default: () => [],
        },
        displayPlace: {
            type: String,
            default: 'slider'
        },
        // seconds
        delay: {
            type: Number,
            default: 4,
        },
        showNavigation: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            swiperInstance: null,
        };
    },
    computed: {
        delayInSeconds() {
            return this.delay * 1000;
        },
    },
    watch: {
        items() {
            this.$nextTick(() => this.reinitSwiper());
        },
    },
    mounted() {
        this.$nextTick(() => this.initSwiper());
    },
    beforeDestroy() {
        this.destroySwiper();
    },
    methods: {
        initSwiper() {
            const container = this.$refs.swiperContainer;
            if (!container)
                return;
            this.swiperInstance = new Swiper(container, { modules: [Navigation, Pagination, Autoplay], ...this.options });
        },
        destroySwiper() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
                this.swiperInstance = null;
            }
        },
        reinitSwiper() {
            this.destroySwiper();
            this.initSwiper();
        },
    },
});
